import React from "react";
import { requestFlutterMediaPick } from "../../utils/talentFlutterFile";

const FILE_ACCEPT =
  "image/jpeg,image/png,image/jpg,video/mp4,video/quicktime,image/*,video/*";

/**
 * CHOOSE FILE control — overlay <input> for browsers/WebViews that support it,
 * or GameStatus.postMessage for Flutter when useFlutterBridge is true.
 */
export default function ChooseFileButton({
  onInputChange,
  useFlutterBridge = false,
  compact = false,
  label = "CHOOSE FILE",
  multiple = false,
}) {
  if (useFlutterBridge) {
    return (
      <button
        type="button"
        className={`yu-choose-btn${compact ? " yu-choose-btn--compact" : ""}`}
        onClick={() => requestFlutterMediaPick()}
      >
        {label}
      </button>
    );
  }

  return (
    <label className={`yu-choose-btn${compact ? " yu-choose-btn--compact" : ""}`}>
      {label}
      <input
        type="file"
        accept={FILE_ACCEPT}
        multiple={multiple}
        className="yu-file-input-overlay"
        onChange={onInputChange}
      />
    </label>
  );
}
